import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import VariantSelectOption from 'personalization-lib/components/variantSelect/VariantSelectOption';
import ManageVariantsLink from 'personalization-lib/components/shared/links/ManageVariantsLink';
import Skeleton from 'personalization-lib/components/shared/display/Skeleton';
import useVariants from 'personalization-lib/hooks/useVariants';
import { getVariantName } from 'personalization-lib/utils/variantSelect';
import { jsx as _jsx } from "react/jsx-runtime";
const VariantSelect = ({
  value,
  strategyId,
  onChange,
  onError
}) => {
  const {
    variants,
    loading,
    error
  } = useVariants(strategyId, onError);
  if (loading) {
    return /*#__PURE__*/_jsx(Select, {
      "data-test-id": "variant-select",
      minInlineSize: "200px",
      menuWidth: 400,
      buttonUse: "tertiary-light",
      buttonSize: "small",
      disabled: true,
      valueRenderer: () => /*#__PURE__*/_jsx(Skeleton, {
        blockSize: "1em",
        borderRadius: "400",
        use: "on-dark"
      })
    });
  }
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "variant-select",
    value: value,
    error: Boolean(error),
    dropdownFooter: /*#__PURE__*/_jsx(ManageVariantsLink, {
      strategyId: strategyId
    }),
    placeholder: I18n.text('personalizationLib.variantSelect.placeholder'),
    onChange: e => onChange(e.target.value),
    optionComponent: VariantSelectOption,
    options: variants.map(variant => Object.assign({
      value: variant.assetCoordinates.id,
      text: getVariantName(variant.assetData),
      loading,
      error
    }, variant)),
    menuWidth: 400,
    buttonUse: "tertiary-light",
    buttonSize: "small"
  });
};
export default VariantSelect;